'use client'

import { default as SelectReactSelect } from 'react-select'
import { useTranslations } from 'next-intl'

import {
  ClearIndicator,
  darkReactSelectStyles,
  DropdownIndicator,
  getReactSelectStyles,
  reactSelectTheme,
} from '@/utils/select.config'

export const Select = ({ classicSelect = false, ...props }) => {
  const t = useTranslations('Select')

  const reactSelectStyles = getReactSelectStyles(classicSelect)
  const baseStyles = props.darkMode ? darkReactSelectStyles : reactSelectStyles
  const styles = props.styles ? { ...baseStyles, ...props.styles } : baseStyles
  const menuPortalTarget =
    'menuPortalTarget' in props
      ? props.menuPortalTarget
      : typeof document !== 'undefined'
        ? document.body
        : undefined

  return (
    <SelectReactSelect
      styles={styles}
      theme={reactSelectTheme}
      components={{ ClearIndicator, DropdownIndicator }}
      menuPlacement="auto"
      menuPosition="fixed"
      menuPortalTarget={menuPortalTarget}
      menuShouldScrollIntoView={false}
      placeholder={t('placeholder')}
      noOptionsMessage={({ inputValue }) =>
        inputValue
          ? t('noOptionsMessage.found')
          : t('noOptionsMessage.startTyping')
      }
      {...props}
    />
  )
}
